import React from "react";
import { Container, Row, Col } from "react-bootstrap";
// import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import developer from "../../Assets/developer.jpg";
import Skills from "../Resume/skils";
import Wrapper from "../Home/Wrappe";
// import { SKILLS, TOOLS } from "../../Constants";

function About() {
  return (
    <Wrapper>
      <div id="about">

    <Container fluid className="about-section">
      <Container>
        <Row style={{ justifyContent: "center"}}>
          <Col
            md={7}
            style={{
              justifyContent: "center",

              paddingBottom: "50px",
            }}
          >
            <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
              <strong className="purple">About Me</strong>
            </h1>
            <Aboutcard />
          </Col>
          <Col md={5} style={{ paddingBottom: "50px" }} className="about-img">
            <img src={developer} alt="about" className="image-style" />
          </Col>
        </Row>
        
      </Container>
    </Container>
      </div>
    </Wrapper>
  );
}

export default About;
